import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Payroll Module Service Stores
 * Everee integration for worker payroll management
 */
export const payrollStores: ServiceStoreConfig[] = [
  // Session management (existing)
  {
    name: "everee-embedded-sessions",
    options: {
      enableStorage: false, // Sessions are short-lived, don't cache
      enableErrorNotifications: true,
      idField: "sessionId",
    },
  },

  // Worker Management endpoints
  {
    name: "everee-embedded-workers",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },
  {
    name: "everee-workers",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },
  {
    name: "everee-worker-data",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },
  {
    name: "everee-candidates",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },
  {
    name: "everee-files",
    options: {
      enableErrorNotifications: true,
      idField: "fileUrl",
    },
  },

  // Timesheet Management
  {
    name: "everee-timesheets",
    options: {
      enableErrorNotifications: true,
      idField: "shiftId",
    },
  },

  // Work Locations
  {
    name: "everee-work-locations",
    // Collides with the same-named app/view store; service store must win the key.
    override: true,
    options: {
      enableErrorNotifications: true,
      idField: "evereeWorkLocationId",
    },
  },

  // Payroll Operations endpoints
  {
    name: "everee-payables",
    options: {
      enableErrorNotifications: true,
      idField: "payableId",
    },
  },
  {
    name: "everee-early-pay",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },
  {
    name: "everee-realtime-payroll",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },

  // Financial Reports endpoints (read-only)
  {
    name: "everee-payment-history",
    options: {
      enableErrorNotifications: true,
      idField: "paymentId",
    },
  },
  {
    name: "everee-gross-earnings",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },
  {
    name: "everee-expenses",
    options: {
      enableErrorNotifications: true,
      idField: "period",
    },
  },

  // ==================== Earning Profiles ====================
  {
    name: "earning-profiles",
    // Collides with the same-named app/view store; service store must win the key.
    override: true,
    options: {
      enableErrorNotifications: true,
      idField: "earningProfileId",
    },
  },
  {
    name: "earning-line-items",
    options: {
      enableErrorNotifications: true,
      idField: "earningLineItemId",
    },
  },

  // ==================== Deduction Profiles ====================
  {
    name: "deduction-profiles",
    // Collides with the same-named app/view store; service store must win the key.
    override: true,
    options: {
      enableErrorNotifications: true,
      idField: "deductionProfileId",
    },
  },
  {
    name: "deduction-line-items",
    options: {
      enableErrorNotifications: true,
      idField: "deductionLineItemId",
    },
  },

  // ==================== LNI Codes ====================
  {
    name: "lni-codes",
    // Collides with the same-named app/view store; service store must win the key.
    override: true,
    options: {
      enableErrorNotifications: true,
      idField: "lniCodeId",
    },
  },
  {
    name: "employee-lni-assignments",
    options: {
      enableErrorNotifications: true,
      idField: "assignmentId",
    },
  },
  {
    name: "pay-period-lni-entries",
    options: {
      enableErrorNotifications: true,
      idField: "entryId",
    },
  },

  // ==================== Worker Profile Assignments ====================
  {
    name: "worker-profile-assignments",
    options: {
      enableErrorNotifications: true,
      idField: "workerId",
    },
  },

  // ==================== Pay Periods ====================
  {
    name: "pay-periods",
    options: {
      enableErrorNotifications: true,
      idField: "payPeriodId",
    },
  },

  // ==================== Payroll Entries ====================
  {
    name: "payroll-entries",
    options: {
      enableErrorNotifications: true,
      idField: "entryId",
    },
  },

  // ==================== Vending Integration (Phase 5) ====================
  {
    name: "vending-transactions",
    options: {
      enableErrorNotifications: true,
      idField: "transactionId",
    },
  },

  // ==================== TCP Import ====================
  {
    name: "tcp-hours",
    options: {
      enableErrorNotifications: true,
      enableStorage: false,
      idField: "recordId",
    },
  },
  {
    name: "tcp-employees",
    options: {
      enableErrorNotifications: true,
      enableStorage: false,
      idField: "id",
    },
  },
  {
    name: "timesheet-import",
    options: {
      enableErrorNotifications: true,
      enableStorage: false,
      idField: "index",
    },
  },

  // ==================== TCP CSV Import ====================
  {
    name: "timesheet-csv-import",
    options: {
      enableErrorNotifications: true,
      enableStorage: false,
      idField: "row",
    },
  },

  // ==================== Bulk Paystub Download ====================
  {
    name: "everee-paystub-bulk",
    options: {
      enableErrorNotifications: true,
      enableStorage: false, // Don't cache bulk download results - one-time bulk operation
      idField: "workerId",
    },
  },

  // ==================== GL Mapping (Phase 3) ====================
  {
    name: "payroll-gl-mappings",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "glMappingId",
      pagination: 200,
    },
  },
  {
    name: "payroll-gl-overrides",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "overrideId",
      pagination: 50,
    },
  },
];
